"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    PropTypes = _interopDefault(require("prop-types")),
    styles$f = require("@material-ui/core/styles"),
    TextField = _interopDefault(require("@material-ui/core/TextField")),
    InputAdornment = _interopDefault(require("@material-ui/core/InputAdornment")),
    Divider = _interopDefault(require("@material-ui/core/Divider")),
    classNames = _interopDefault(require("classnames")),
    InputMasked = _interopDefault(require("react-maskedinput")),
    ErrorIcon = _interopDefault(require("@material-ui/icons/ErrorOutlineOutlined")),
    FormControl = _interopDefault(require("@material-ui/core/FormControl")),
    MaterialTable = _interopDefault(require("@material-ui/core/Table")),
    TableBody = _interopDefault(require("@material-ui/core/TableBody")),
    TableCell = _interopDefault(require("@material-ui/core/TableCell")),
    TableRow = _interopDefault(require("@material-ui/core/TableRow")),
    Paper = _interopDefault(require("@material-ui/core/Paper")),
    MaterialTableHead = _interopDefault(require("@material-ui/core/TableHead")),
    TableSortLabel = _interopDefault(require("@material-ui/core/TableSortLabel")),
    Tooltip$2 = _interopDefault(require("@material-ui/core/Tooltip")),
    Pagination$1 = _interopDefault(require("react-paginate")),
    RightIcon = _interopDefault(require("@material-ui/icons/ChevronRight")),
    LeftIcon = _interopDefault(require("@material-ui/icons/ChevronLeft")),
    ButtonBase = _interopDefault(require("@material-ui/core/ButtonBase")),
    MaterialButton = _interopDefault(require("@material-ui/core/Button")),
    Link = _interopDefault(require("@material-ui/core/Link")),
    reactRouterDom = require("react-router-dom"),
    MuiCheckBox = _interopDefault(require("@material-ui/core/Checkbox")),
    FormControlLabel = _interopDefault(require("@material-ui/core/FormControlLabel")),
    pickers = require("@material-ui/pickers"),
    DateFnsUtils = _interopDefault(require("@date-io/date-fns")),
    core = require("@material-ui/core"),
    chroma = _interopDefault(require("chroma-js")),
    Select = _interopDefault(require("react-select")),
    MuiRadio = _interopDefault(require("@material-ui/core/Radio")),
    reactContentLoader = require("react-content-loader"),
    Dialog = _interopDefault(require("@material-ui/core/Dialog")),
    DialogActions = _interopDefault(require("@material-ui/core/DialogActions")),
    DialogContent = _interopDefault(require("@material-ui/core/DialogContent")),
    DialogTitle = _interopDefault(require("@material-ui/core/DialogTitle"));

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}

function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function ownKeys(t, e) {
  var r = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function _objectSpread2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ownKeys(r, !0).forEach(function (e) {
      _defineProperty(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ownKeys(r).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var r,
      o,
      a = {},
      n = Object.keys(e);

  for (o = 0; o < n.length; o++) {
    r = n[o], 0 <= t.indexOf(r) || (a[r] = e[r]);
  }

  return a;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var r,
      o,
      a = _objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);

    for (o = 0; o < n.length; o++) {
      r = n[o], 0 <= t.indexOf(r) || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
    }
  }

  return a;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

var styles = function styles(e) {
  return {
    root: {
      borderRadius: e.shape.borderRadius,
      paddingRight: 0,
      borderBottom: 0
    },
    focus: {},
    outlinedInput: {
      border: "1px solid ".concat(e.palette.common.inputBorder),
      "&$error": {
        border: "1px solid ".concat(e.palette.common.error)
      },
      "&$error $errorIcon": {
        display: "inherit"
      },
      "&$error:hover": {
        border: "1px solid ".concat(e.palette.common.error)
      },
      "&:hover": {
        border: "1px solid ".concat(e.palette.common.primary)
      },
      "&$focus": {
        border: "1px solid ".concat(e.palette.common.primary)
      },
      "&$error&$focus": {
        border: "1px solid ".concat(e.palette.common.error)
      },
      backgroundColor: e.palette.common.white,
      borderRadius: e.shape.borderRadius
    },
    input: {
      padding: "8px 10px 10px 10px",
      flex: 1
    },
    divider: {
      width: 1,
      height: 38
    },
    noPadding: {
      padding: 0
    },
    withMargin: {},
    adorment: {
      margin: 0,
      padding: 0,
      whiteSpace: "nowrap",
      "&$withMargin": {
        marginLeft: e.spacing(1)
      },
      "&>*": {
        padding: 7
      },
      backgroundColor: "#fff",
      height: "auto",
      maxHeight: "inherit",
      "&$end": {
        borderRadius: "0 ".concat(e.shape.borderRadius - 1, "px ").concat(e.shape.borderRadius - 1, "px 0")
      },
      "&$start": {
        borderRadius: "".concat(e.shape.borderRadius - 1, "px 0 0 ").concat(e.shape.borderRadius - 1, "px")
      }
    },
    start: {},
    end: {},
    error: {},
    errorIcon: {
      color: e.palette.common.error,
      fontSize: 18,
      marginRight: 5,
      display: "none"
    },
    clearUnderline: {
      "&:before": {
        border: "0 !important"
      },
      "&:after": {
        border: "0 !important"
      }
    },
    inputLabel: {
      color: e.palette.common.darkerText
    },
    marginTopWithLabel: {
      marginTop: e.spacing(1)
    },
    formControl: {
      display: "inherit"
    },
    formControlMargin: {}
  };
},
    Input = function () {
  function n() {
    var e, r;

    _classCallCheck(this, n);

    for (var t = arguments.length, o = new Array(t), a = 0; a < t; a++) {
      o[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(r = _possibleConstructorReturn(this, (e = _getPrototypeOf(n)).call.apply(e, [this].concat(o)))), "renderMaskedInput", function (e) {
      e.inputRef;

      var t = _objectWithoutProperties(e, ["inputRef"]);

      return React__default.createElement(InputMasked, _extends({
        mask: r.props.mask
      }, t));
    }), r;
  }

  return _inherits(n, React__default.PureComponent), _createClass(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = e.className,
          o = e.adorment,
          a = e.adormentPosition,
          n = e.showDivider,
          l = e.name,
          i = e.mask,
          s = e.label,
          c = _objectWithoutProperties(e, ["classes", "className", "adorment", "adormentPosition", "showDivider", "name", "mask", "label"]),
          p = "string" == typeof o,
          d = "start" === a && React__default.createElement(React.Fragment, null, React__default.createElement(InputAdornment, {
        className: classNames(t.adorment, _defineProperty({}, t.withMargin, p), t.start)
      }, o), n && React__default.createElement(Divider, {
        className: t.divider
      })),
          u = "end" === a && React__default.createElement(React.Fragment, null, n && React__default.createElement(Divider, {
        className: t.divider
      }), React__default.createElement(InputAdornment, {
        className: classNames(t.adorment, t.end)
      }, o)),
          m = React__default.createElement(ErrorIcon, {
        className: t.errorIcon
      }),
          f = s && React__default.createElement("label", {
        className: t.inputLabel,
        htmlFor: l
      }, s),
          h = i && this.renderMaskedInput;

      return React__default.createElement(FormControl, {
        className: classNames(t.formControl, _defineProperty({}, t.formControlMargin, f))
      }, f, React__default.createElement(TextField, _extends({
        fullWidth: !0,
        className: classNames(r, t.root, _defineProperty({}, t.marginTopWithLabel, f)),
        mask: i,
        name: l,
        InputProps: {
          classes: {
            root: t.outlinedInput,
            input: t.input,
            error: t.error,
            focused: t.focus,
            underline: t.clearUnderline
          },
          startAdornment: d,
          endAdornment: u || m,
          inputComponent: h
        }
      }, c)));
    }
  }]), n;
}();

(Input = styles$f.withStyles(styles, {
  withTheme: !0
})(Input)).propTypes = {
  className: PropTypes.string,
  adorment: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  adormentPosition: PropTypes.string,
  showDivider: PropTypes.bool,
  mask: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string
};

var Input$1 = Input,
    styles$1 = function styles$1(e) {
  return {
    cell: {
      padding: "25px 15px",
      whiteSpace: "nowrap",
      borderWidth: "2px"
    },
    cellMobile: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "none"
    })
  };
},
    TableHead = function () {
  function n() {
    var e, r;

    _classCallCheck(this, n);

    for (var t = arguments.length, o = new Array(t), a = 0; a < t; a++) {
      o[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(r = _possibleConstructorReturn(this, (e = _getPrototypeOf(n)).call.apply(e, [this].concat(o)))), "createSortHandler", function (t) {
      return function (e) {
        r.props.onRequestSort(e, t);
      };
    }), r;
  }

  return _inherits(n, React__default.PureComponent), _createClass(n, [{
    key: "render",
    value: function value() {
      var t = this,
          e = this.props,
          r = e.order,
          o = e.orderBy,
          a = e.rows,
          n = e.classes,
          l = e.enableSorting;
      return React__default.createElement(MaterialTableHead, null, React__default.createElement(TableRow, null, a.map(function (e) {
        return React__default.createElement(TableCell, {
          key: e.id,
          align: e.alignment || "left",
          padding: e.disablePadding ? "none" : "default",
          sortDirection: o === e.id && r,
          className: classNames(n.cell, _defineProperty({}, n.cellMobile, e.hideInMobile))
        }, l ? React__default.createElement(Tooltip$2, {
          title: "Sort",
          placement: e.numeric ? "bottom-end" : "bottom-start",
          enterDelay: 300
        }, React__default.createElement(TableSortLabel, {
          active: o === e.id,
          direction: r,
          onClick: t.createSortHandler(e.id)
        }, e.label)) : React__default.createElement("div", null, e.label));
      }, this)));
    }
  }]), n;
}();

TableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number.isRequired,
  enableSorting: PropTypes.bool
};

var TableHead$1 = styles$f.withStyles(styles$1)(TableHead),
    styles$2 = function styles$2(e) {
  return {
    root: {
      display: "flex",
      alignItems: "center"
    },
    pageInfo: _defineProperty({
      marginRight: e.spacing(1)
    }, e.breakpoints.down("sm"), {
      display: "none"
    }),
    pagination: {
      marginLeft: "auto",
      display: "flex",
      "& a": {
        border: "1px solid ".concat(e.palette.common.lightBorder),
        marginLeft: -1,
        padding: "6px 12px",
        textAlign: "center",
        display: "block",
        backgroundColor: e.palette.common.white
      },
      "& li:first-child a": {
        padding: 0,
        borderRadius: "".concat(e.shape.borderRadius, "px 0 0 ").concat(e.shape.borderRadius, "px")
      },
      "& li:first-child button": {
        padding: "3px 4px 2px 4px"
      },
      "& li:last-child a": {
        padding: 0,
        borderRadius: "0 ".concat(e.shape.borderRadius, "px ").concat(e.shape.borderRadius, "px 0")
      },
      "& li:last-child button": {
        padding: "3px 4px 2px 4px"
      },
      "& li.active a": {
        backgroundColor: e.palette.common.primary,
        borderColor: e.palette.common.primary,
        color: e.palette.common.white
      }
    },
    paginationList: {}
  };
},
    TablePigination = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = e.className,
          o = e.dataCount,
          a = e.onPageChange,
          n = e.rowsPerPage,
          l = e.currentPage,
          i = e.pageCount;
      return React__default.createElement("div", {
        className: classNames(t.root, r)
      }, React__default.createElement("div", {
        className: t.pageInfo
      }, "Viewing ", React__default.createElement("b", null, l * n + 1, "-", l * n + n), " of ", React__default.createElement("b", null, o)), React__default.createElement(Pagination$1, {
        containerClassName: t.pagination,
        previousLabel: React__default.createElement(ButtonBase, null, React__default.createElement(LeftIcon, null)),
        nextLabel: React__default.createElement(ButtonBase, null, React__default.createElement(RightIcon, null)),
        breakLabel: null,
        pageCount: i,
        marginPagesDisplayed: 0,
        pageRangeDisplayed: 4,
        onPageChange: a,
        subContainerClassName: "pages pagination",
        activeClassName: "active",
        forcePage: l
      }));
    }
  }]), e;
}();

TablePigination.propTypes = {
  classes: PropTypes.object.isRequired,
  dataCount: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  className: PropTypes.string
};

var Pagination = styles$f.withStyles(styles$2)(TablePigination),
    styles$3 = function styles$3(e) {
  return {
    root: {
      width: "100%",
      marginTop: e.spacing(3),
      padding: "0 15px"
    },
    noBackground: {
      background: "transparent",
      boxShadow: "none",
      padding: 0,
      margin: 0
    },
    table: {
      "& tr:last-child td": {
        borderBottom: "none"
      }
    },
    tableWrapper: {},
    cell: {
      padding: "18px 15px"
    },
    cellMobile: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "none"
    }),
    row: {},
    noResults: {
      textAlign: "center",
      fontSize: "22px",
      color: "#6b6c6f"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      height: 60
    },
    pagination: {
      marginLeft: "auto"
    }
  };
};

function desc(e, t, r) {
  return t[r] < e[r] ? -1 : t[r] > e[r] ? 1 : 0;
}

function stableSort(e, o) {
  var t = e.map(function (e, t) {
    return [e, t];
  });
  return t.sort(function (e, t) {
    var r = o(e[0], t[0]);
    return 0 !== r ? r : e[1] - t[1];
  }), t.map(function (e) {
    return e[0];
  });
}

function getSorting(e, r) {
  return "desc" === e ? function (e, t) {
    return desc(e, t, r);
  } : function (e, t) {
    return -desc(e, t, r);
  };
}

var Table = function () {
  function a() {
    var e, n;

    _classCallCheck(this, a);

    for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
      r[o] = arguments[o];
    }

    return _defineProperty(_assertThisInitialized(n = _possibleConstructorReturn(this, (e = _getPrototypeOf(a)).call.apply(e, [this].concat(r)))), "state", {
      order: "asc",
      orderBy: "calories",
      selected: [],
      rowsPerPage: n.props.rowsPerPage || 10
    }), _defineProperty(_assertThisInitialized(n), "handleRequestSort", function (e, t) {
      var r = t,
          o = "desc";
      n.state.orderBy === t && "desc" === n.state.order && (o = "asc"), n.setState({
        order: o,
        orderBy: r
      }), n.props.onPageChange({
        selected: 0
      });
    }), _defineProperty(_assertThisInitialized(n), "handleSelectAllClick", function (e) {
      e.target.checked ? n.setState(function (e) {
        return {
          selected: e.data.map(function (e) {
            return e.id;
          })
        };
      }) : n.setState({
        selected: []
      });
    }), _defineProperty(_assertThisInitialized(n), "handleClick", function (e, t) {
      var r = n.state.selected,
          o = r.indexOf(t),
          a = [];
      -1 === o ? a = a.concat(r, t) : 0 === o ? a = a.concat(r.slice(1)) : o === r.length - 1 ? a = a.concat(r.slice(0, -1)) : 0 < o && (a = a.concat(r.slice(0, o), r.slice(o + 1))), n.setState({
        selected: a
      }), n.props.onRowClick && n.props.onRowClick(e, t);
    }), _defineProperty(_assertThisInitialized(n), "handleChangeRowsPerPage", function (e) {
      n.setState({
        rowsPerPage: e.target.value
      });
    }), _defineProperty(_assertThisInitialized(n), "isSelected", function (e) {
      return -1 !== n.state.selected.indexOf(e);
    }), _defineProperty(_assertThisInitialized(n), "componentDidMount", function () {
      n.setState({
        orderBy: n.props.orderBy
      }), n.setState({
        order: n.props.order
      });
    }), n;
  }

  return _inherits(a, React__default.PureComponent), _createClass(a, [{
    key: "render",
    value: function value() {
      var o = this,
          e = this.props,
          a = e.classes,
          t = e.data,
          n = e.metadata,
          r = e.showNoResults,
          l = e.footerText,
          i = e.enableSorting,
          s = e.showFooter,
          c = e.noBackground,
          p = e.showEmptyRows,
          d = e.currentPage,
          u = e.onPageChange,
          m = d || 0,
          f = this.state,
          h = f.order,
          y = f.orderBy,
          g = f.selected,
          b = f.rowsPerPage,
          _ = p ? b - Math.min(b, t.length - m * b) : 0,
          R = 1 / n.length * 100 + "%",
          C = Math.ceil(t.length / b),
          P = !!n.find(function (e) {
        return !!e.label;
      });

      return React__default.createElement("div", null, React__default.createElement(Paper, {
        className: classNames(a.root, _defineProperty({}, a.noBackground, c))
      }, React__default.createElement("div", {
        className: a.tableWrapper
      }, React__default.createElement(MaterialTable, {
        className: a.table,
        "aria-labelledby": "tableTitle"
      }, React__default.createElement("colgroup", null, n.map(function (e) {
        return React__default.createElement("col", {
          key: e.id,
          width: e.width || R
        });
      })), P && React__default.createElement(TableHead$1, {
        numSelected: g.length,
        order: h,
        orderBy: y,
        onSelectAllClick: this.handleSelectAllClick,
        onRequestSort: this.handleRequestSort,
        rowCount: t.length,
        rows: n,
        enableSorting: i
      }), r ? React__default.createElement(TableBody, null, React__default.createElement(TableRow, {
        style: {
          height: 49
        }
      }, React__default.createElement(TableCell, {
        colSpan: n.length,
        className: classNames(a.cell, a.noResults)
      }, "No Results Found"))) : React__default.createElement(TableBody, null, stableSort(t, getSorting(h, y)).slice(m * b, m * b + b).map(function (r, e) {
        var t = o.isSelected(r.id);
        return React__default.createElement(TableRow, {
          hover: !0,
          onClick: function onClick(e) {
            return o.handleClick(e, r.id);
          },
          role: "checkbox",
          "aria-checked": t,
          tabIndex: -1,
          key: e,
          selected: t,
          className: a.row
        }, n.map(function (e, t) {
          return React__default.createElement(TableCell, {
            key: t,
            align: e.alignment,
            className: classNames(a.cell, e.className, _defineProperty({}, a.cellMobile, e.hideInMobile))
          }, r[e.renderingField]);
        }));
      }), 0 < _ && React__default.createElement(TableRow, {
        style: {
          height: 49 * _
        }
      }, React__default.createElement(TableCell, {
        colSpan: n.length,
        className: a.cell
      })))))), s && React__default.createElement("div", {
        className: a.footer
      }, React__default.createElement("div", null, l), 1 < C && React__default.createElement(Pagination, {
        className: a.pagination,
        dataCount: t.length,
        onPageChange: u,
        currentPage: m,
        rowsPerPage: b,
        pageCount: C
      })));
    }
  }]), a;
}();

Table.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  metadata: PropTypes.array.isRequired,
  onRowClick: PropTypes.func,
  showNoResults: PropTypes.bool,
  rowsPerPage: PropTypes.number,
  footerText: PropTypes.object,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  enableSorting: PropTypes.bool,
  showFooter: PropTypes.bool,
  noBackground: PropTypes.bool,
  showEmptyRows: PropTypes.bool
};

var Table$1 = styles$f.withStyles(styles$3)(Table),
    styles$4 = function styles$4(e) {
  return {
    root: {
      borderColor: e.palette.common.inputBorder,
      height: "40px",
      backgroundColor: e.palette.common.white,
      whiteSpace: "nowrap",
      textTransform: "none",
      boxShadow: "none"
    },
    textButton: {
      height: "auto",
      color: e.palette.common.primary,
      padding: 0,
      minWidth: 0
    },
    default: getButtonClass(e, e.palette.common.primary),
    error: getButtonClass(e, e.palette.common.error),
    negative: getButtonClass(e, e.palette.common.negative),
    warning: getButtonClass(e, e.palette.common.warning),
    secondary: getButtonClass(e, e.palette.common.secondary),
    success: getButtonClass(e, e.palette.common.success),
    outlined: {
      color: e.palette.common.primary,
      border: "1px solid ".concat(e.palette.common.primary),
      "&:hover": {
        color: e.palette.common.white,
        backgroundColor: e.palette.common.primary,
        boxShadow: "none"
      }
    },
    outlined2: {
      color: e.palette.common.outlinedButtonText,
      border: "1px solid ".concat(e.palette.common.inputBorder),
      "&:hover": {
        color: e.palette.common.primary,
        border: "1px solid ".concat(e.palette.common.primary),
        backgroundColor: e.palette.common.white,
        boxShadow: "none"
      }
    },
    iconLeft: {
      fontSize: 16,
      marginRight: 3
    },
    iconRight: {
      fontSize: 16,
      marginLeft: 3
    }
  };
},
    getButtonClass = function getButtonClass(e, t) {
  return {
    color: e.palette.common.white,
    backgroundColor: t,
    border: "1px solid ".concat(t),
    "&:hover": {
      color: t,
      backgroundColor: e.palette.common.white,
      border: "1px solid ".concat(t),
      boxShadow: "none"
    }
  };
},
    Button = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e,
          t = this.props,
          r = t.classes,
          o = (t.className, t.text),
          a = t.onClick,
          n = (t.icon, t.iconPosition),
          l = (t.outlined, t.color),
          i = _objectWithoutProperties(t, ["classes", "className", "text", "onClick", "icon", "iconPosition", "outlined", "color"]),
          s = this.props.variant || "contained";

      return React__default.createElement(MaterialButton, _extends({
        variant: s,
        className: classNames(r.root, (e = {}, _defineProperty(e, r.outlined, "outlined" === s), _defineProperty(e, r.outlined2, "outlined2" === s), _defineProperty(e, r[l || "default"], "contained" === s), _defineProperty(e, r.textButton, "text" === s), e)),
        onClick: a
      }, i), "left" === n && React__default.createElement(this.props.icon, {
        className: r.iconLeft
      }), o, "right" === n && React__default.createElement(this.props.icon, {
        className: r.iconRight
      }));
    }
  }]), e;
}();

(Button = styles$f.withStyles(styles$4)(Button)).propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.object,
  iconPosition: PropTypes.string,
  state: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string
};
var Button$1 = Button,
    white = "#fff",
    black = "#212121",
    darkBlue = "#004a8c",
    darkerBlue = "#003a74",
    backgroundColor = "#f1f4f7",
    borderColor1 = "#e6eaee",
    borderColor2 = "#c7d0d9",
    borderColor3 = "#e1e4e8",
    gray = "#666666",
    fontFamily = "'Lato',sans-serif",
    hoverColor = "#eff2f7",
    lightGray = "#9e9e9e",
    success = "#6aad40",
    warning = "#f7b500",
    error = "#b00020",
    negative = "#f36274",
    secondary = "#38afd1",
    primaryDisabled = "#789FC2",
    secondaryDisabled = "#95D1E4",
    sideBarWidth = 220,
    fontSize = "14px",
    boldFont = "bold",
    yellow = "#e5ad12",
    red = "#df4545",
    defaultTheme = styles$f.createMuiTheme({
  dimension: {
    sideBarWidth: sideBarWidth
  },
  palette: {
    primary: {
      main: white,
      contrastText: black
    },
    secondary: {
      main: darkBlue,
      contrastText: white
    },
    text: {
      primary: black,
      secondary: darkBlue
    },
    common: {
      black: black,
      white: white,
      primary: darkBlue,
      primaryDarker: darkerBlue,
      inputLabel: black,
      inputBorder: borderColor2,
      lightBorder: borderColor3,
      lightText: lightGray,
      darkerText: gray,
      success: success,
      error: error,
      warning: warning,
      negative: negative,
      secondary: secondary,
      primaryDisabled: primaryDisabled,
      secondaryDisabled: secondaryDisabled,
      boldFont: boldFont,
      yellow: yellow,
      red: red
    },
    background: {
      default: backgroundColor,
      paper: white
    },
    action: {
      selected: null
    }
  },
  typography: {
    fontFamily: fontFamily,
    h1: {
      fontSize: 38,
      fontWeight: boldFont,
      marginBottom: "20px"
    },
    h2: {
      fontSize: 32,
      fontWeight: boldFont
    },
    h3: {
      fontSize: 26,
      fontWeight: boldFont
    },
    h4: {
      fontSize: 20,
      fontWeight: boldFont
    },
    h5: {
      fontSize: 16,
      fontWeight: boldFont
    },
    h6: {
      fontSize: 12
    },
    body1: {
      color: black,
      fontSize: fontSize
    },
    body2: {
      fontSize: fontSize
    },
    subheading: {
      color: black
    }
  },
  shape: {
    borderRadius: 6
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none",
        "&:hover": {
          color: darkBlue,
          borderColor: darkBlue,
          backgroundColor: white
        }
      },
      text: {
        fontSize: fontSize
      }
    },
    MuiInputAdornment: {
      root: {
        paddingLeft: "5px"
      }
    },
    MuiTypography: {
      colorPrimary: {
        color: black
      }
    },
    MuiTableCell: {
      head: {
        fontWeight: boldFont,
        color: black,
        fontSize: fontSize,
        borderBottomColor: borderColor1
      }
    },
    MuiTableRow: {
      root: {
        "&$hover:hover": {
          backgroundColor: hoverColor
        }
      },
      hover: {}
    },
    MuiTableSortLabel: {
      root: {
        "&:hover": {
          color: darkBlue
        },
        "&:focus": {
          color: darkBlue
        }
      },
      active: {
        color: darkBlue
      }
    },
    MuiPaper: {
      elevation2: {
        boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.08)"
      }
    },
    MuiListItem: {
      button: {
        "&:hover": {
          backgroundColor: hoverColor
        }
      }
    },
    MuiTab: {
      root: {
        fontFamily: fontFamily,
        textTransform: "none",
        "& span": {
          color: white
        },
        opacity: .7,
        fontSize: fontSize,
        "&$selected": {
          opacity: 1
        }
      }
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        fontSize: 20,
        color: secondary
      },
      "& h6": {
        color: secondary
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: white
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        color: black
      },
      transitionContainer: {
        "& p": {
          color: black
        }
      }
    },
    MuiPickersDay: {
      day: {
        color: black,
        "& p": {
          fontSize: fontSize
        }
      },
      daySelected: {
        backgroundColor: secondary,
        color: white
      },
      dayDisabled: {
        color: secondary
      },
      current: {
        color: secondary
      }
    },
    MuiPickersYear: {
      color: black,
      yearSelected: {
        color: secondary
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: secondary
      }
    }
  }
});

function arrowGenerator(e) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: "transparent transparent ".concat(e, " transparent")
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: "".concat(e, " transparent transparent transparent")
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: "transparent ".concat(e, " transparent transparent")
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: "transparent transparent transparent ".concat(e)
      }
    }
  };
}

var styles$5 = function styles$5(e) {
  return {
    button: {
      margin: e.spacing(1)
    },
    lightTooltip: {
      backgroundColor: e.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: e.shadows[1],
      fontSize: 11
    },
    arrowPopper: arrowGenerator(e.palette.grey[700]),
    arrow: {
      position: "absolute",
      fontSize: 6,
      width: "3em",
      height: "3em",
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid"
      }
    },
    tooltip: {
      position: "relative"
    }
  };
},
    Tooltip = function () {
  function n() {
    var e, t;

    _classCallCheck(this, n);

    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) {
      o[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(t = _possibleConstructorReturn(this, (e = _getPrototypeOf(n)).call.apply(e, [this].concat(o)))), "state", {
      arrowRef: null
    }), _defineProperty(_assertThisInitialized(t), "handleArrowRef", function (e) {
      t.setState({
        arrowRef: e
      });
    }), t;
  }

  return _inherits(n, React__default.PureComponent), _createClass(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = e.text,
          o = _objectWithoutProperties(e, ["classes", "text"]);

      return React__default.createElement(styles$f.ThemeProvider, {
        theme: defaultTheme
      }, React__default.createElement(Tooltip$2, _extends({
        title: React__default.createElement(React__default.Fragment, null, r, React__default.createElement("span", {
          className: t.arrow,
          ref: this.handleArrowRef
        })),
        classes: {
          popper: t.arrowPopper,
          tooltip: t.tooltip
        },
        PopperProps: {
          popperOptions: {
            modifiers: {
              arrow: {
                enabled: Boolean(this.state.arrowRef),
                element: this.state.arrowRef
              }
            }
          }
        }
      }, o), this.props.children));
    }
  }]), n;
}();

Tooltip.propTypes = {
  text: PropTypes.string.isRequired
};

var Tooltip$1 = styles$f.withStyles(styles$5)(Tooltip),
    styles$6 = function styles$6(e) {
  return {
    root: {
      display: "flex",
      alignItems: "center",
      color: e.palette.common.lightText,
      "&:hover": {
        color: e.palette.common.primary,
        textDecoration: "none",
        "& path": {
          fill: e.palette.common.primary
        }
      },
      "& path": {
        fill: e.palette.common.lightText
      }
    },
    iconLeft: {
      fontSize: 16,
      marginRight: 3
    }
  };
};

function TextLink(e) {
  var t = e.classes,
      r = e.to,
      o = e.icon,
      a = e.className,
      n = e.children,
      l = _objectWithoutProperties(e, ["classes", "to", "icon", "className", "children"]);

  return React__default.createElement(Link, _extends({
    component: reactRouterDom.Link,
    to: r,
    className: classNames(t.root, a)
  }, l), o && React__default.createElement("icon", {
    className: t.iconLeft
  }), n);
}

TextLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  to: PropTypes.string
}, TextLink.defaultProps = {
  className: "",
  icon: null,
  to: ""
};

var TextLink$1 = styles$f.withStyles(styles$6, {
  withTheme: !0
})(TextLink),
    CheckboxNormal = function CheckboxNormal() {
  return React__default.createElement("svg", {
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    id: "UID",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "UI-Elements",
    transform: "translate(-1159.000000, -1361.000000)",
    stroke: "#C7D0D9",
    strokeWidth: "2"
  }, React__default.createElement("g", {
    id: "svg-files",
    transform: "translate(1128.000000, 1336.000000)"
  }, React__default.createElement("rect", {
    id: "checkbox-normal",
    x: "32",
    y: "26",
    width: "16",
    height: "16",
    rx: "6"
  })))));
},
    CheckboxChecked = function CheckboxChecked() {
  return React__default.createElement("svg", {
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    id: "UID",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "UI-Elements",
    transform: "translate(-1159.000000, -1389.000000)"
  }, React__default.createElement("g", {
    id: "svg-files",
    transform: "translate(1128.000000, 1336.000000)"
  }, React__default.createElement("g", {
    id: "checkbox-checked-secondary",
    transform: "translate(31.000000, 53.000000)"
  }, React__default.createElement("rect", {
    id: "bg",
    stroke: "#38AFD1",
    strokeWidth: "2",
    fill: "#38AFD1",
    x: "1",
    y: "1",
    width: "16",
    height: "16",
    rx: "6"
  }), React__default.createElement("path", {
    d: "M5.42258898,8.24407768 C5.09715207,7.91864077 4.56951459,7.91864077 4.24407768,8.24407768 C3.91864077,8.56951459 3.91864077,9.09715207 4.24407768,9.42258898 L7.41074435,12.5892557 C7.73618126,12.9146926 8.26381874,12.9146926 8.58925565,12.5892557 L12.7559223,6.42258898 C13.0813592,6.09715207 13.0813592,5.56951459 12.7559223,5.24407768 C12.4304854,4.91864077 11.9028479,4.91864077 11.577411,5.24407768 L8,10.8214887 L5.42258898,8.24407768 Z",
    id: "ic-tick",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(8.500000, 8.916667) rotate(6.000000) translate(-8.500000, -8.916667) "
  }))))));
},
    styles$7 = function styles$7(e) {
  return {
    root: {
      "&$secondary": {
        "&:hover": {
          background: "transparent"
        }
      }
    },
    primary: {
      padding: "12px 6px 6px 12px"
    },
    secondary: {
      padding: "12px 6px 6px 12px"
    },
    colorSecondary: {
      "&:hover": {
        background: "transparent"
      }
    },
    checked: {
      "&$primary": {
        "& svg rect": {
          stroke: e.palette.common.primary,
          fill: e.palette.common.primary
        },
        "&:hover": {
          background: "transparent"
        }
      },
      "&$secondary": {
        "& svg rect": {
          stroke: e.palette.common.secondary,
          fill: e.palette.common.secondary
        },
        "&:hover": {
          background: "transparent"
        }
      }
    },
    disabled: {
      "&$checked": {
        "&$primary": {
          "& svg rect": {
            stroke: "none",
            fill: e.palette.common.primaryDisabled
          }
        },
        "&$secondary": {
          "& svg rect": {
            stroke: "none",
            fill: e.palette.common.secondaryDisabled
          }
        }
      },
      "& svg rect": {
        stroke: "#e1e4e8",
        fill: "#f1f4f7"
      }
    },
    formControlLabel: {
      color: e.palette.common.black,
      paddingTop: "6px",
      paddingRight: "10px"
    }
  };
},
    CheckBox = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = e.disabled,
          o = e.checked,
          a = e.onChange,
          n = e.color,
          l = e.label,
          i = _objectWithoutProperties(e, ["classes", "disabled", "checked", "onChange", "color", "label"]);

      return React__default.createElement(FormControlLabel, {
        control: React__default.createElement(MuiCheckBox, _extends({
          icon: React__default.createElement(CheckboxNormal, null),
          checkedIcon: React__default.createElement(CheckboxChecked, null),
          className: classNames("primary" === n ? t.primary : t.secondary),
          classes: {
            disabled: t.disabled,
            checked: t.checked
          },
          checked: o,
          disabled: r,
          onChange: a
        }, i)),
        label: l,
        classes: {
          label: t.formControlLabel
        }
      });
    }
  }]), e;
}();

CheckBox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  color: PropTypes.string
};

var CheckBox$1 = styles$f.withStyles(styles$7, {
  withTheme: !0
})(CheckBox),
    DatePickerIcon = function DatePickerIcon() {
  return React__default.createElement("svg", {
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    version: "1.1"
  }, React__default.createElement("title", null, "ic-calendar-day"), React__default.createElement("desc", null, "Created with Sketch."), React__default.createElement("g", {
    id: "UID",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, React__default.createElement("g", {
    id: "Customers-Transactions3-1-(Filters-Tick1)",
    transform: "translate(-597.000000, -328.000000)",
    fill: "#666666"
  }, React__default.createElement("g", {
    id: "Filters",
    transform: "translate(250.000000, 220.000000)"
  }, React__default.createElement("g", {
    id: "Search-customers",
    transform: "translate(40.000000, 74.000000)"
  }, React__default.createElement("g", {
    id: "Search-date",
    transform: "translate(178.000000, 24.000000)"
  }, React__default.createElement("g", {
    id: "ic-calendar-day",
    transform: "translate(129.000000, 10.000000)"
  }, React__default.createElement("path", {
    d: "M14.0625,2.25 L12.375,2.25 L12.375,0.28125 C12.375,0.1265625 12.2484375,0 12.09375,0 L11.53125,0 C11.3765625,0 11.25,0.1265625 11.25,0.28125 L11.25,2.25 L4.5,2.25 L4.5,0.28125 C4.5,0.1265625 4.3734375,0 4.21875,0 L3.65625,0 C3.5015625,0 3.375,0.1265625 3.375,0.28125 L3.375,2.25 L1.6875,2.25 C0.755859375,2.25 0,3.00585938 0,3.9375 L0,16.3125 C0,17.2441406 0.755859375,18 1.6875,18 L14.0625,18 C14.9941406,18 15.75,17.2441406 15.75,16.3125 L15.75,3.9375 C15.75,3.00585938 14.9941406,2.25 14.0625,2.25 Z M14.625,16.3125 C14.625,16.621875 14.371875,16.875 14.0625,16.875 L1.6875,16.875 C1.378125,16.875 1.125,16.621875 1.125,16.3125 L1.125,6.75 L14.625,6.75 L14.625,16.3125 Z M14.625,5.625 L1.125,5.625 L1.125,3.9375 C1.125,3.628125 1.378125,3.375 1.6875,3.375 L14.0625,3.375 C14.371875,3.375 14.625,3.628125 14.625,3.9375 L14.625,5.625 Z M3.9375,13.5 L7.3125,13.5 C7.621875,13.5 7.875,13.246875 7.875,12.9375 L7.875,9.5625 C7.875,9.253125 7.621875,9 7.3125,9 L3.9375,9 C3.628125,9 3.375,9.253125 3.375,9.5625 L3.375,12.9375 C3.375,13.246875 3.628125,13.5 3.9375,13.5 Z M4.5,10.125 L6.75,10.125 L6.75,12.375 L4.5,12.375 L4.5,10.125 Z"
  }))))))));
},
    styles$8 = function styles$8(e) {
  return {
    root: {
      width: "100%"
    },
    datePickerInput: {
      border: "0px solid ".concat(e.palette.common.inputBorder),
      borderRadius: e.shape.borderRadius,
      "& svg": {
        fontSize: "20px",
        color: e.palette.common.darkerText
      },
      "&:hover": {
        "& svg g": {
          fill: e.palette.common.primary
        }
      }
    },
    MuiFormLabel: {
      color: e.palette.common.darkerText,
      fontFamily: e.palette.common.fontFamily,
      fontSize: e.palette.common.fontSize,
      padding: "2px 8px 8px 2px"
    },
    clearUnderline: {
      "&:before": {
        border: "0 !important"
      },
      "&:after": {
        border: "0 !important"
      }
    },
    outlinedInput: {
      border: "1px solid ".concat(e.palette.common.inputBorder),
      height: "40px",
      borderRadius: e.shape.borderRadius,
      "&:hover": {
        border: "1px solid ".concat(e.palette.common.primary)
      },
      "&$focus": {
        border: "1px solid ".concat(e.palette.common.primary)
      },
      "&$error": {
        border: "1px solid ".concat(e.palette.common.error),
        "& svg": {
          color: e.palette.common.error
        }
      },
      "&$error&$focus": {
        border: "1px solid ".concat(e.palette.common.error)
      }
    },
    focus: {},
    error: {},
    input: {
      padding: "8px 10px 10px 10px",
      flex: 1
    },
    marginTopWithLabel: {
      marginTop: e.spacing(1)
    }
  };
},
    DatePicker = function () {
  function r(e) {
    var t;
    return _classCallCheck(this, r), (t = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, e))).state = {
      date: null
    }, t;
  }

  return _inherits(r, React__default.PureComponent), _createClass(r, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = e.label,
          o = e.handleDateChange,
          a = e.date,
          n = e.dateFormat,
          l = e.error,
          i = e.helperText,
          s = _objectWithoutProperties(e, ["classes", "label", "handleDateChange", "date", "dateFormat", "error", "helperText"]),
          c = (n || "DD/MM/YYYY").toUpperCase(),
          p = "Please enter a valid date (" + c + ")",
          d = r && React__default.createElement(core.FormLabel, {
        className: t.MuiFormLabel
      }, r);

      return React__default.createElement(pickers.MuiPickersUtilsProvider, {
        utils: DateFnsUtils
      }, React__default.createElement(core.FormControl, {
        class: t.root
      }, d, React__default.createElement(pickers.KeyboardDatePicker, _extends({
        fullWidth: !0,
        autoOk: "true",
        onChange: o,
        className: classNames(t.datePickerInput, _defineProperty({}, t.marginTopWithLabel, d)),
        format: n,
        InputProps: {
          classes: {
            root: t.outlinedInput,
            input: t.input,
            focused: t.focus,
            underline: t.clearUnderline,
            error: t.error
          }
        },
        placeholder: c,
        okLabel: "",
        cancelLabel: "",
        value: a,
        keyboardIcon: React__default.createElement(DatePickerIcon, null),
        error: l,
        helperText: i,
        invalidDateMessage: p
      }, s))));
    }
  }]), r;
}();

DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  dateFormat: PropTypes.string.isRequired,
  handleDateChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string
};

var DatePicker$1 = styles$f.withStyles(styles$8, {
  withTheme: !0
})(DatePicker),
    getOptionConfig = function getOptionConfig(e, t, r, o) {
  return 0 === e.length ? e : e.map(function (e) {
    return _objectSpread2({}, e, {
      color: e.color ? e.color : getmultiValueColorCodeByType(t, r, o).color
    });
  });
},
    getmultiValueColorCodeByType = function getmultiValueColorCodeByType(e, t, r) {
  if (t) return {
    color: t
  };
  var o = e.toLowerCase();
  return "success" === o ? typecolors(r).success : "primary" === o ? typecolors(r).primary : "secondary" === o ? typecolors(r).secondary : typecolors(r).default;
},
    typecolors = function typecolors(e) {
  return {
    default: {
      color: e.palette.common.black,
      backgroundColor: e.palette.common.white,
      hoverbackgroundColor: e.palette.common.hoverColor
    },
    success: {
      color: e.palette.common.success
    },
    primary: {
      color: e.palette.common.primary
    },
    secondary: {
      color: e.palette.common.secondary
    }
  };
},
    colourStyles = function colourStyles(c, r) {
  return {
    control: function control(e) {
      var t = typecolors(c);
      return _objectSpread2({}, e, {
        color: c.palette.common.black,
        backgroundColor: t.default.backgroundColor,
        minHeight: c.dimension.dropDownHeight,
        borderRadius: c.shape.borderRadius,
        border: "1px solid ".concat(r ? c.palette.common.error : c.palette.common.inputBorder),
        "&:hover": {
          border: "1px solid ".concat(r ? c.palette.common.error : c.palette.common.primary)
        },
        "&:focus-within": {
          border: "1px solid ".concat(r ? c.palette.common.error : c.palette.common.primary)
        },
        "&:focus": {
          border: "1px solid ".concat(r ? c.palette.common.error : c.palette.common.primary)
        },
        boxShadow: "none"
      });
    },
    option: function option(e, t) {
      var r,
          o = t.data,
          a = t.isDisabled,
          n = t.isFocused,
          l = t.isSelected,
          i = chroma(o.color),
          s = typecolors(c);
      return _objectSpread2({}, e, (_defineProperty(r = {
        backgroundColor: a ? null : l ? o.color : n ? i.alpha(.1).css() : null,
        "&:hover": {
          backgroundColor: s.default.hoverbackgroundColor
        }
      }, "backgroundColor", s.default.backgroundColor), _defineProperty(r, "color", s.default.color), _defineProperty(r, "fontSize", c.typography.caption.fontSize), _defineProperty(r, "cursor", a ? "not-allowed" : "default"), _defineProperty(r, ":active", _objectSpread2({}, e[":active"], {
        backgroundColor: !a && (l ? o.color : i.alpha(.3).css())
      })), r));
    },
    placeholder: function placeholder() {
      return {
        color: c.palette.common.black
      };
    },
    singleValue: function singleValue(e, t) {
      return _objectSpread2({}, e, {
        color: t.data.color
      });
    },
    multiValue: function multiValue(e, t) {
      var r = t.data;
      return _objectSpread2({}, e, {
        backgroundColor: chroma(r.color).alpha(.1).css(),
        borderRadius: c.shape.borderRadius,
        fontSize: "12px",
        lineHeight: "22px"
      });
    },
    multiValueLabel: function multiValueLabel(e, t) {
      return _objectSpread2({}, e, {
        color: t.data.color
      });
    },
    multiValueRemove: function multiValueRemove(e, t) {
      var r = t.data;
      return _objectSpread2({}, e, {
        color: r.color,
        ":hover": {
          backgroundColor: r.color,
          color: c.palette.common.white
        }
      });
    }
  };
},
    styles$9 = function styles$9(e) {
  return {
    error: {
      color: e.palette.common.error
    },
    inputLabel: {
      color: e.palette.common.darkerText,
      paddingLeft: "3px"
    },
    marginTopWithLabel: {
      marginTop: e.spacing(1)
    },
    formControl: {
      display: "inherit"
    }
  };
},
    DropDownSelect = function () {
  function n() {
    var e, t;

    _classCallCheck(this, n);

    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) {
      o[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(t = _possibleConstructorReturn(this, (e = _getPrototypeOf(n)).call.apply(e, [this].concat(o)))), "handleChange", function (e) {
      t.props.onChange(e);
    }), t;
  }

  return _inherits(n, React__default.PureComponent), _createClass(n, [{
    key: "render",
    value: function value() {
      var e,
          t = this.props,
          r = t.classes,
          o = (t.selectedOption, t.isMulti),
          a = t.optionList,
          n = t.theme,
          l = t.appearance,
          i = t.label,
          s = t.customizedcolor,
          c = t.error,
          p = t.helperText,
          d = t.value,
          u = getOptionConfig(a, l, s, n),
          m = i && React__default.createElement("div", {
        className: r.formControlMargin
      }, React__default.createElement("label", {
        className: r.inputLabel
      }, i)),
          f = React__default.createElement("div", {
        className: classNames(r.marginTopWithLabel)
      }, React__default.createElement(Select, {
        closeMenuOnSelect: !o,
        onChange: this.handleChange,
        options: u,
        isMulti: o,
        styles: colourStyles(n, c),
        placeholder: this.props.placeholder,
        value: a.find(function (e) {
          return e.value === d;
        })
      }));
      return React__default.createElement(styles$f.ThemeProvider, {
        theme: defaultTheme
      }, React__default.createElement(core.FormControl, {
        className: classNames(r.formControl, (e = {}, _defineProperty(e, r.formControlMargin, m), _defineProperty(e, r.error, c), e))
      }, m, f, c && React__default.createElement(core.FormHelperText, {
        className: r.error
      }, p)));
    }
  }]), n;
}();

(DropDownSelect = styles$f.withStyles(styles$9, {
  withTheme: !0
})(DropDownSelect)).propTypes = {
  label: PropTypes.string,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func,
  optionList: PropTypes.array,
  customizedcolor: PropTypes.string,
  placeholder: PropTypes.string,
  appearance: PropTypes.oneOf(["success", "primary", "secondary", "default"]),
  error: PropTypes.bool,
  helperText: PropTypes.string
}, DropDownSelect.defaultProps = {
  isMulti: !1,
  optionList: [],
  label: "",
  appearance: "default",
  placeholder: "- Select -"
};

var DropDownSelect$1 = DropDownSelect,
    RadioButtonNormal = function RadioButtonNormal() {
  return React__default.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    id: "UID",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "UI-Elements",
    transform: "translate(-1191.000000, -1360.000000)",
    stroke: "#C7D0D9"
  }, React__default.createElement("g", {
    id: "svg-files",
    transform: "translate(1128.000000, 1336.000000)"
  }, React__default.createElement("circle", {
    id: "radio-normal",
    cx: "73",
    cy: "34",
    r: "9"
  })))));
},
    RadioButtonChecked = function RadioButtonChecked() {
  return React__default.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    id: "UID",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "UI-Elements",
    transform: "translate(-1191.000000, -1413.000000)"
  }, React__default.createElement("g", {
    id: "svg-files",
    transform: "translate(1128.000000, 1336.000000)"
  }, React__default.createElement("g", {
    id: "radio-checked-white",
    transform: "translate(64.000000, 78.000000)"
  }, React__default.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    cx: "9",
    cy: "9",
    r: "9"
  }), React__default.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#FFFFFF",
    cx: "9",
    cy: "9",
    r: "4"
  }))))));
},
    styles$a = function styles$a(e) {
  return {
    primary: {},
    secondary: {},
    checked: {
      "&$primary": {
        "& svg circle": {
          stroke: e.palette.common.primary
        },
        "& svg circle+circle": {
          fill: e.palette.common.primary
        }
      },
      "&$secondary": {
        "& svg circle": {
          stroke: e.palette.common.secondary
        },
        "& svg circle+circle": {
          fill: e.palette.common.secondary
        }
      }
    },
    disabled: {
      "&$checked": {
        "&$primary": {
          "& svg circle": {
            stroke: e.palette.common.primaryDisabled
          },
          "& svg circle+circle": {
            fill: e.palette.common.primaryDisabled
          }
        },
        "&$secondary": {
          "& svg circle": {
            stroke: e.palette.common.secondaryDisabled
          },
          "& svg circle+circle": {
            fill: e.palette.common.secondaryDisabled
          }
        }
      },
      "& svg g": {
        stroke: "#e1e4e8",
        fill: "#f1f4f7"
      }
    }
  };
},
    RadioButton = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = (e.className, e.label, e.disabled),
          o = e.checked,
          a = e.color,
          n = e.onChange,
          l = _objectWithoutProperties(e, ["classes", "className", "label", "disabled", "checked", "color", "onChange"]);

      return React__default.createElement(MuiRadio, _extends({
        icon: React__default.createElement(RadioButtonNormal, null),
        checkedIcon: React__default.createElement(RadioButtonChecked, null),
        className: classNames("primary" === a ? t.primary : t.secondary),
        classes: {
          disabled: t.disabled,
          checked: t.checked
        },
        checked: o,
        disabled: r,
        onChange: n
      }, l));
    }
  }]), e;
}();

RadioButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  inputProps: PropTypes.object,
  color: PropTypes.string,
  onChange: PropTypes.func
};

var RadioButton$1 = styles$f.withStyles(styles$a, {
  withTheme: !0
})(RadioButton),
    styles$b = function styles$b(e) {
  return {
    root: {
      flexDirection: "row"
    },
    label: {
      color: e.palette.common.darkerText
    }
  };
},
    RadioButtonGroup = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = (e.className, e.label),
          o = e.disabled,
          a = e.color,
          n = e.onChange,
          l = e.options,
          i = _objectWithoutProperties(e, ["classes", "className", "label", "disabled", "color", "onChange", "options"]);

      return React__default.createElement(core.FormControl, null, r && React__default.createElement("label", {
        className: t.label
      }, r), React__default.createElement(core.RadioGroup, _extends({
        className: t.root,
        "aria-label": "radioButton",
        onChange: n,
        value: l[0].value
      }, i), l.map(function (e) {
        return React__default.createElement(FormControlLabel, {
          value: e.value,
          control: React__default.createElement(RadioButton$1, {
            color: a,
            disabled: o
          }),
          label: e.label
        });
      })));
    }
  }]), e;
}();

RadioButtonGroup.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired
};

var RadioButtonGroup$1 = styles$f.withStyles(styles$b, {
  withTheme: !0
})(RadioButtonGroup),
    styles$c = function styles$c(e) {
  return {
    root: {
      border: "1px solid #38afd1",
      borderRadius: e.shape.borderRadius,
      color: "#38afd1",
      backgroundColor: "#fff",
      fontSize: "12px",
      padding: "2px 4px 3px 4px"
    },
    error: {
      borderColor: e.palette.common.error,
      color: e.palette.common.error
    },
    negative: {
      borderColor: e.palette.common.negative,
      color: e.palette.common.negative
    },
    warning: {
      borderColor: e.palette.common.warning,
      color: e.palette.common.warning
    },
    success: {
      borderColor: e.palette.common.success,
      color: e.palette.common.success
    },
    default: {
      borderColor: "#38afd1",
      color: "#38afd1"
    },
    secondary: {
      borderColor: "#b3b3b3",
      color: "#b3b3b3"
    },
    chip: {
      margin: e.spacing(1)
    }
  };
},
    Tag = function Tag(e) {
  var t = e.classes,
      r = e.label,
      o = e.type;
  return React__default.createElement("span", {
    className: classNames(t.root, t[o || "default"])
  }, r);
};

Tag.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string
};

var Tag$1 = styles$f.withStyles(styles$c)(Tag),
    styles$d = function styles$d(e) {
  return {
    root: {
      padding: 30
    },
    title: {
      flex: 1,
      color: e.palette.common.primary,
      marginBottom: 20
    },
    loader: {
      height: 150,
      width: "100%"
    }
  };
},
    InfoWidget = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          r = e.isLoading,
          o = e.title,
          a = e.actionButton,
          n = e.contentLoader;
      return React__default.createElement(Paper, {
        className: t.root
      }, r ? n || React__default.createElement(reactContentLoader.List, {
        className: t.loader
      }) : React__default.createElement(React.Fragment, null, React__default.createElement(core.Grid, {
        container: !0,
        justify: "space-between"
      }, React__default.createElement("div", {
        className: t.title
      }, React__default.createElement(core.Typography, {
        variant: "h5",
        color: "inherit",
        noWrap: !0
      }, o)), React__default.createElement("div", null, a)), this.props.children));
    }
  }]), e;
}();

InfoWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  actionButton: PropTypes.object,
  contentLoader: PropTypes.object
};

var InfoWidget$1 = styles$f.withStyles(styles$d)(InfoWidget),
    styles$e = {
  text: {
    color: "#83888a"
  },
  button: {
    color: "#252529"
  }
},
    AlertDialog = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React__default.PureComponent), _createClass(e, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.title,
          r = e.text,
          o = e.redirectLink,
          a = e.open,
          n = e.handleAlertClose,
          l = e.buttonText,
          i = e.classes;
      return React__default.createElement("div", null, React__default.createElement(Dialog, {
        open: a,
        onClose: n,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
      }, React__default.createElement(DialogTitle, {
        id: "alert-dialog-title"
      }, t), React__default.createElement(DialogContent, null, React__default.createElement("div", {
        id: "alert-dialog-description",
        className: i.text
      }, r)), React__default.createElement(DialogActions, null, React__default.createElement(MaterialButton, {
        className: i.button,
        onClick: n,
        component: reactRouterDom.Link,
        to: o
      }, l || "Go Back"))));
    }
  }]), e;
}(),
    AlertDialog$1 = styles$f.withStyles(styles$e)(AlertDialog);

exports.AlertDialog = AlertDialog$1, exports.Button = Button$1, exports.CheckBox = CheckBox$1, exports.DatePicker = DatePicker$1, exports.Dropdown = DropDownSelect$1, exports.InfoWidget = InfoWidget$1, exports.Input = Input$1, exports.RadioButton = RadioButton$1, exports.RadioButtonGroup = RadioButtonGroup$1, exports.Table = Table$1, exports.Tag = Tag$1, exports.TextLink = TextLink$1, exports.Tooltip = Tooltip$1, exports.defaultTheme = defaultTheme;